import { render, staticRenderFns } from "./DrawerArrow.vue?vue&type=template&id=722f06ee"
import script from "./DrawerArrow.vue?vue&type=script&lang=js"
export * from "./DrawerArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports